/**
 * @generated SignedSource<<944b9dcc5511a7a083ac8d375928c160>>
 * @relayHash 81b02e9df6ff164d6e5e30623e94b54e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 89a7f1ea4dfad888e2142fe392d0ca352745bea99db492be020e1fbec409f90b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "89a7f1ea4dfad888e2142fe392d0ca352745bea99db492be020e1fbec409f90b",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
